/* eslint-disable eqeqeq */
import moment from "moment";

const state = {
    id: 0,
    name: "",
    description: "",
    level: "",
    status: "DRAFT",
    type: "SBMPTN",
    variant: "SCHEDULED",
    tryouts: [],
    joinCode: "",
    opened_at: 0,
    closed_at: 0,
    created_at: 0,
    discussion_opened_at: 0,
    discussion_special_at: 0,
    opened_normal: 0,
    closed_normal: 0,
    isSticky: false,
    isPrivate: false,
    grade: 12,
    dependency_id: null,
    user_groups: [],
    category: "",
    image: "",
};

const mutations = {
    tryout_group_reset: function (state) {
        state.id = 0;
        state.name = "";
        state.description = "";
        state.level = "";
        state.type = "SBMPTN";
        state.variant = "SCHEDULED";
        state.created_at = 0;
        state.status = "DRAFT";
        state.tryouts = [];
        state.joinCode = "";
        state.opened_at = 0;
        state.closed_at = 0;
        state.closed_normal = 0;
        state.opened_normal = 0;
        state.discussion_opened_at = 0;
        state.discussion_special_at = 0;
        state.grade = 12;
        state.isSticky = false;
        state.isPrivate = false;
        state.dependency_id = null;
        state.user_groups = [];
        state.category = "";
        state.image = "";
    },

    tryout_group_init: function (state, payload) {
        state.id = payload.id;
        state.name = payload.name;
        state.description = payload.description;
        state.level = payload.level;
        state.type = payload.type;
        state.variant = payload.variant;
        state.created_at = payload.type;
        state.status = payload.status;
        state.tryouts = payload.tryouts;
        state.joinCode = payload.join_code;
        state.opened_at = payload.opened_at;
        state.closed_at = payload.closed_at;
        state.discussion_opened_at = payload.discussion_opened_at;
        state.discussion_special_at = payload.discussion_special_at;
        state.opened_normal = payload.opened_normal;
        state.closed_normal = payload.closed_normal;
        state.discussion_special_at = payload.discussion_special_at;
        state.grade = payload.grade;
        state.isSticky = payload.is_sticky;
        state.isPrivate = payload.is_private;
        state.dependency_id = payload.dependency_id;
        state.user_groups = payload.user_groups;
        state.category = payload.category;
        state.image = payload.image;
    },

    tryout_group_set_id: function (state, payload) {
        state.id = payload;
    },

    tryout_group_set_name: function (state, payload) {
        state.name = payload;
    },

    tryout_group_set_description: function (state, payload) {
        state.description = payload;
    },

    tryout_group_set_type: function (state, payload) {
        state.type = payload;
    },

    tryout_group_set_variant: function (state, payload) {
        state.variant = payload;
    },

    tryout_group_set_join_code: function (state, payload) {
        state.joinCode = payload;
    },

    tryout_group_add_tryout: function (state, payload) {
        state.tryouts.push(payload);
    },

    tryout_group_remove_tryout: function (state, payload) {
        var index = state.tryouts.findIndex(function (element) {
            return element.id == payload.id;
        });

        if (index != -1) state.tryouts.splice(index, 1);
    },

    tryout_group_set_status: function (state, payload) {
        state.status = payload;
    },

    tryout_group_set_grade: function (state, payload) {
        state.grade = payload;
    },

    tryout_group_set_is_sticky: function (state, payload) {
        state.isSticky = payload;
    },

    tryout_group_set_is_private: function (state, payload) {
        state.isPrivate = payload;
    },

    tryout_group_set_dependency_id: function (state, payload) {
        state.dependency_id = payload;
    },

    tryout_group_set_user_groups: function (state, payload) {
        state.user_groups = payload;
    },

    tryout_group_set_category: function (state, payload) {
        state.category = payload;
    },

    tryout_group_set_image: function (state, payload) {
        state.image = payload;
    },
};

const getters = {
    openedAt: function (state) {
        var time = 0;
        state.tryouts.forEach(function (tryout) {
            var tryoutStartTime = moment(
                tryout.start_date + " " + tryout.start_time,
                "YYYY-MM-DD HH:mm",
            ).format("x");
            if (time == 0 || tryoutStartTime < time)
                time = Number(tryoutStartTime);
        });

        return time;
    },

    closedAt: function (state) {
        var time = 0;
        state.tryouts.forEach(function (tryout) {
            var tryoutEndTime = moment(
                tryout.end_date + " " + tryout.end_time,
                "YYYY-MM-DD HH:mm",
            ).format("x");
            if (time == 0 || tryoutEndTime > time) time = Number(tryoutEndTime);
        });

        return time;
    },
};

export default { state, mutations, getters };



// WEBPACK FOOTER //
// ./src/modules/tryout_group/stores/tryout_group.js